import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMapMarker,
  faArrowUpFromWaterPump,
} from "@fortawesome/free-solid-svg-icons";
import "./sidebar.css"; // Ensure this path is correct
import mapmarkericon from "./assets/images/mapmarker.png"; // Adjust the path as necessary
import warpo from "./warpo.png"; // Adjust the path as necessary
const Sidebar = ({
  radius,
  handleRadiusChange,
  markerCount,
  circleCenter,
  handleClearCircle,
  userFriendlyLocation,
  isPickingLocation, // Add this prop to track if the location is being picked
  setIsPickingLocation, // Function to toggle picking location mode
  isBuildingWell,
  setIsBuildingWell,
}) => {
  const [selectedRadius, setSelectedRadius] = useState("");
  const [selectedMarker, setSelectedMarker] = useState(null);
  const [selectedLevel, setSelectedLevel] = useState("");

  const handleButtonClick = (marker) => {
    console.log("Selected Marker:", marker); // Debugging line
    setSelectedMarker(marker);
  };

  const handleClosePopup = () => {
    console.log("Closing Popup"); // Debugging line
    setSelectedMarker(null);
  };

  const handleRadiusChangeInternal = (e) => {
    const value = e.target.value;
    setSelectedRadius(value);
    handleRadiusChange(value);
    console.log("selectedRadius:", selectedRadius);
  };

  const handleLevelChangeInternal = (e) => {
    const value = e.target.value;
    setSelectedLevel(value);
  };

  const [isBuild, setIsBuild] = useState(false);
  const handleBuildClick = () => {
    setIsBuild(!isBuild);
  };

  const [isBrushActive, setIsBrushActive] = useState(false);
  const handleBrushClick = () => {
    setIsBrushActive(!isBrushActive);
  };

  // Function to toggle location pick mode
  const handlePickLocationClick = () => {
    setIsPickingLocation(!isPickingLocation);
    console.log("Pick a location toggled:", !isPickingLocation);
    // Additional logic to enable map interaction or location picker
  };

  const MarkerListModal = ({ markerCount, handleCloseModal }) => {
    return (
      <div className="modal-overlay">
        <div className="modal-content">
          <h2>List of Wells</h2>
          {markerCount.map((marker, index) => (
            <div key={index} className="marker-item">
              <h3>Well {marker.name}</h3>
              <p>
                <strong>Nearby:</strong> {marker.distance.toFixed(2)} km
              </p>
              <p>
                <strong>Current Level:</strong> {marker.waterlevel}
              </p>
              <p>
                <strong>Predicted in 5y:</strong> {marker.prediction}
              </p>
              <p>
                <strong>Prediction in 5y if tubewell built:</strong>{" "}
                {marker.decreasedlevel.toFixed(2)}
              </p>
              <hr />
            </div>
          ))}
          <button onClick={handleCloseModal}>Close</button>
        </div>
      </div>
    );
  };
  // const handleShowMarkerList = () => {
  //   const newWindow = window.open("", "_blank", "width=800,height=600");

  //   const markerListContent = markerCount.map((marker, index) => {
  //     return `
  //       <div style="padding: 10px; border-bottom: 1px solid #ccc;">
  //         <h3>Well ${marker.name}</h3>
  //         <p><strong>Nearby:</strong> ${marker.distance.toFixed(2)} km</p>
  //         <p><strong>Current Level:</strong> ${marker.waterlevel}</p>
  //         <p><strong>Predicted in 5y:</strong> ${marker.prediction}</p>
  //         <p><strong>Prediction in 5y if tubewell built:</strong> ${marker.decreasedlevel.toFixed(2)}</p>
  //       </div>
  //     `;
  //   }).join('');

  //   const content = `
  //     <html>
  //       <head>
  //         <title>Marker List</title>
  //         <style>
  //           body {
  //             font-family: Arial, sans-serif;
  //             margin: 20px;
  //             color: #333;
  //           }
  //           h3 {
  //             color: #2980b9;
  //           }
  //           .marker-info {
  //             margin-top: 15px;
  //           }
  //           .marker-info strong {
  //             color: #2c3e50;
  //           }
  //         </style>
  //       </head>
  //       <body>
  //         <h2>List of Wells</h2>
  //         ${markerListContent}
  //       </body>
  //     </html>
  //   `;

  //   newWindow.document.write(content);
  //   newWindow.document.close();
  // };

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleShowMarkerList = () => {
    document.body.classList.add("modal-open");
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    document.body.classList.remove("modal-open");
    setIsModalOpen(false);
  };

  return (
    <div className="sidebar">
      <div className="sidebar-content">
        <ul>
          {/* Button to toggle location picking */}
          {/* <li>
            <button onClick={handlePickLocationClick}>
              {isPickingLocation ? "Cancel Location Pick" : "Pick a Location"}
            </button>
          </li> */}

          {/* Radius selection when location is being picked */}
          {isPickingLocation && (
            <li>
              <p>Pick a place in the map to show information</p>
              <label htmlFor="radius-select">Select Radius:</label>
              <select
                id="radius-select"
                value={selectedRadius}
                onChange={handleRadiusChangeInternal}
              >
                <option value="">-Select Radius-</option>
                <option value="10">10 km</option>
                <option value="20">20 km</option>
                <option value="30">30 km</option>
                <option value="40">40 km</option>
                <option value="50">50 km</option>
              </select>
            </li>
          )}

          {/* Show the location details only when Pick a Location mode is active */}
          {isPickingLocation && markerCount !== null && selectedRadius && (
            <li>
              <p>
                The map shows the location of well markers within the selected
                radius around the selected point.
              </p>
              <p>{`Number of wells within ${selectedRadius} km: ${markerCount.length}`}</p>
              <ul>
                {markerCount.map((marker, index) => (
                  <button key={index} onClick={() => handleButtonClick(marker)}>
                    <li>
                      {`  (${index + 1}) Well ${
                        marker.name
                      } nearby: current level: ${
                        marker.waterlevel
                      }, predicted in 5y: ${marker.prediction}`}
                    </li>
                  </button>
                ))}
              </ul>
              <li>
                <button onClick={handleClearCircle}>Clear</button>
              </li>
            </li>
          )}

          {/* Option for clearing the circle (location pick) */}

          {isBuildingWell && (
            <li>
              <div className="radius-dropdown">
              <p>Pick a place in the map to build tubewell</p>
                <label htmlFor="radius-select">Select Level:</label>
                <select
                  id="radius-select"
                  value={selectedLevel}
                  onChange={handleLevelChangeInternal}
                >
                  <option value="">--Select Level--</option>
                  <option value="50">50 L/day</option>
                  <option value="100">100 L/day</option>
                  <option value="200">200 L/day</option>
                  <option value="250">250 L/day</option>
                  <option value="300">300 L/day</option>
                </select>
                {/* <li>
                  For every 100L/day, the nearby water level will decrease by
                  0.5ft.
                </li> */}
              </div>
            </li>
          )}

          {/* Display water level decrease based on selected level */}

          <li>
            {selectedLevel && (
              <div>
                <li>{`Selected Level: ${selectedLevel}`}</li>
                <li>
                  <button onClick={handleBuildClick}>
                    <FontAwesomeIcon
                      icon={faArrowUpFromWaterPump}
                      className="fa-icon"
                    />
                    {"Show the prediction of water level decrease"}
                  </button>
                </li>
                {isBuild && (
                  <li>
                    View the effect in radius of:{" "}
                    <select
                      id="radius-select"
                      value={selectedRadius}
                      onChange={handleRadiusChangeInternal}
                    >
                      <option value="">-Radius-</option>
                      <option value="10">10 km</option>
                      <option value="20">20 km</option>
                      <option value="30">30 km</option>
                      <option value="40">40 km</option>
                      <option value="50">50 km</option>
                    </select>
                  </li>
                )}

                {markerCount !== null && selectedRadius && (
                  <>
                    <p>{`Number of wells within ${radius} km: ${markerCount.length}`}</p>

                    <button onClick={handleShowMarkerList}>
                      Show All Wells in Separate Window
                    </button>
                    {isModalOpen && (
                      <MarkerListModal
                        markerCount={markerCount}
                        handleCloseModal={handleCloseModal}
                      />
                    )}
                    {/* <ul className="marker-list">
                      {markerCount.map((marker, index) => (
                        <li key={index}>
                          <button
                            className="marker-button"
                            onClick={() => handleButtonClick(marker)}
                          >
                            <div className="marker-title">{`(${
                              index + 1
                            }) Well ${marker.name}`}</div>
                            <div className="marker-info">
                              Nearby:{" "}
                              <span className="marker-value">
                                {marker.distance.toFixed(2)} km
                              </span>
                              <br />
                              Current Level:{" "}
                              <span className="marker-value">
                                {marker.waterlevel}
                              </span>
                              <br />
                              Predicted in 5y:{" "}
                              <span className="marker-value">
                                {marker.prediction}
                              </span>
                              <br />
                              Prediction in 5y if tubewell built:{" "}
                              <span className="marker-value">
                                {marker.decreasedlevel.toFixed(2)}
                              </span>
                            </div>
                          </button>
                        </li>
                      ))}
                    </ul> */}
                  </>
                )}

                <li>
                  <button onClick={handleClearCircle}>Clear</button>
                </li>
              </div>
            )}
          </li>
        </ul>
      </div>
      <div className="sidebar-footer"></div>
    </div>
  );
};

export default Sidebar;
